import { defMathOp } from "./compile/emit.js";
const [add, add2, add3, add4] = defMathOp("+");
export {
  add,
  add2,
  add3,
  add4
};
